export class ValidateClaudeEnterpriseKeyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "checks",
            "baseName": "checks",
            "type": "Array<ClaudeEnterpriseKeyCheck>",
            "format": ""
        },
        {
            "name": "organizations",
            "baseName": "organizations",
            "type": "Array<ClaudeEnterpriseKeyOrganization>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValidateClaudeEnterpriseKeyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
